import React, { FunctionComponent } from 'react';
import { OfferGlobal, OfferItem, PageWrapper } from 'components/presentional';
import { Redirect, useParams } from 'react-router-dom';
import { usePages, usePosts } from 'hooks';
import { WPAcfGlobalOfferPage, WPAcfOfferItem } from 'types/acf';
import { WPSimpleArticle } from 'types/articles';
import { useRouteTranslations } from 'utils';
import { WPSimplePage } from 'types/pages';
import { CustomArticleSlugTypes } from 'types/global';

interface OwnProps {}

type OfferPageProps = Omit<JSX.IntrinsicElements['article'], 'children'> & OwnProps;

const OfferPage: FunctionComponent<OfferPageProps> = props => {
  const GLOBAL_OFFER_PAGE_SLUG_TYPE: CustomArticleSlugTypes = 'global_offer';
  let { offerId } = useParams<any>();
  const { translateSlug } = useRouteTranslations();
  const { data: post, loading: postLoading } = usePosts<WPSimpleArticle<WPAcfOfferItem>>({ slug: offerId });
  const { data: page, loading: pageLoading } = usePages<WPSimplePage<WPAcfGlobalOfferPage>>({ slug: translateSlug(GLOBAL_OFFER_PAGE_SLUG_TYPE) });
  const [postData] = post || [];
  const [pageData] = page || [];

  if (!offerId) {
    return <Redirect to={translateSlug('not_found')} />;
  }

  return (
    <PageWrapper title={postData?.yoast_title} meta={postData?.yoast_meta} loading={postLoading} name={GLOBAL_OFFER_PAGE_SLUG_TYPE}>
      {postLoading && <div>Loading...</div>}
      {postData && !postLoading && <OfferItem data={postData} />}
      {pageData && !pageLoading && <OfferGlobal data={pageData} />}
    </PageWrapper>
  );
};

export default OfferPage;
